import { ONLINE_ORDERING_AUTOMATED_STORE_REACTIVATION } from 'constants/featureFlags';

export function hasAutomatedStoreReactivationFeatureFlag(betaFeatureFlags) {
  return betaFeatureFlags?.includes(
    ONLINE_ORDERING_AUTOMATED_STORE_REACTIVATION
  );
}
